import { useEffect } from "react";
import SectionCard from "../components/production/SectionCard";
import { useProductionStore } from "../stores/production";
import {
  PageHeader,
  PagePanel,
  PageShell,
} from "../components/ui/page/PageShell";

const Production = () => {
  const { setProduction2 } = useProductionStore();

  // Vide le store production2 lorsque l'on arrive sur la page Production
  useEffect(() => {
    setProduction2({});
  }, []);

  return (
    <PageShell>
      <PageHeader
        eyebrow="Pilotage"
        title="Productions"
        description="Tableaux de suivi et indicateurs de production."
      />

      <PagePanel>
        <div className="min-h-0 flex-1 overflow-y-auto p-4 sm:p-5">
          <SectionCard />
        </div>
      </PagePanel>
    </PageShell>
  );
};

export default Production;
